
import { Vue, Component, Prop } from "vue-property-decorator";
import InboxConversationItem from "@/components/inbox/InboxConversationItem.vue";
import { Conversation } from "@/generated/graphql";

@Component({
  components: {
    InboxConversationItem,
  },
})
export default class InboxConversations extends Vue {
  @Prop({type: Array, default: () => []}) readonly conversations!: Conversation[];
  @Prop({type: String, required: true}) readonly currentUserId!: string;
  @Prop({ type: String, default: '' }) readonly selectedConversationId!: string;

  get conversationsExist(): boolean {
    return this.conversations.length > 0;
  }
}
